import styled from 'styled-components';
import { blue } from '../../styles/colors';

export const CollapseContainer = styled.div``;

export const Title = styled.h5`
  font-size: 16px;
  padding: 0 5px;
  margin: 13px 0 10px 0;
  padding-right: 25px;
  position: relative;
  cursor: pointer;
  font-weight: normal;
  outline: none;

  i {
    position: absolute;
    pointer-events: none;
    color: ${blue};
    right: 10px;
    top: 0;
    top: ${({ center }) => (center ? 'calc(50% - 8px)' : '3px')};
  }
`;

export const Container = styled.div`
  transition: max-height ${({ animationTime }) => animationTime}ms ease;
  height: auto;
  overflow: hidden;
  padding: 0 5px;
`;
